<template>
  <div id="app" :class="[{'blueSkin':storeskinthemecolor==1},{'greenSkin':storeskinthemecolor==2}]">
    <title>门店管理中心</title>
    <!-- header -->
    <Header @childFin="FtFun" v-if="!isLogin"></Header>

    <!-- S 内容区 -->
    <el-container :class="[{'scale-down':bool,'mainBox':!isLogin}]" v-show="!isQKchild">
      <!-- class="rightView" -->
      <router-view :class="[{'helpRight':helpRight}]"></router-view>
    </el-container>
    <!--S 帮助文档-->
    <helpCenter @helpCenter="closeHelp" v-if="!isLogin&&!isHome"></helpCenter>
    <!--E 帮助文档-->
    <!--E 内容区-->
    <div id="subapp-viewport" v-show="isQKchild"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
  export default {
    name: "app",
    data() {
      return {
        isHome: false, // 是否为首页
        helpRight: true,
        bool: false,
        isLogin: false,
        userInfoMd: '', // 登录信息
        // isQKchild:false,//是否qiankun子项目
        currentSkinStyle:null,//当前皮肤样式表
        staticPath: '/static', 
        storeskinthemecolor:0,//0:橙色 1:蓝色 2：绿色
      };
    },
    filters: {},
    // =============================== 监听 ===============================
    watch: {
      // 判断是否是登录页
      '$route':{
        handler(to, from) {
          // let path = to.path.split('/');
          // let navpath = path[1];
          // if(navpath == 'oldSubDelivery' || navpath == 'oldsubDelivery' || navpath == 'subDelivery'){
          //   this.isQKchild = true;
          // }else{
          //   this.isQKchild = false;
          // }
          if (to.path == '/' || to.path == '/404' || to.path == '/500') {
            this.isLogin = true;
          } else {
            this.isLogin = false;
          }
          if (to.path == '/HomePage') {
            this.isHome = true;
          } else {
            this.isHome = false;
          }
          if (this.$route.name == '首页') {
            this.isHome = true;
            let userBase = '';
            if (localStorage.getItem('userInfoMd')) {
              userBase = JSON.parse(localStorage.getItem('userInfoMd'));
            }
            if (userBase && this.userInfoMd && (this.userInfoMd.ucode != userBase.ucode)) {
              window.location.reload();
            } else if (userBase) {
              this.userInfoMd = userBase;
            }
          } else if (!this.userInfoMd) {
            this.isHome = false;
            if (localStorage.getItem('userInfoMd')) {
              this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
            }
          }
        },
        immediate:true,
        deep:true
      },
      //更改皮肤
      'updateSkin':{
        handler(val, oldval) {
          console.log(val,'状态管理器皮肤')
          this.changeIco()
        },
        immediate: true,
        deep: true
      }
    },
    // =============================== 组件 ===============================
    components: {
      Header: resolve => require(["@/components/common/Header.vue"], resolve),
      helpCenter: resolve => require(["@/components/common/helpCenter.vue"], resolve)
    },
    // =============================== 方法 ===============================
    methods: {
      //关闭帮助文档
      closeHelp(val) {
        this.helpRight = val;
      },
      FtFun(val) {
        this.bool = val;
      },
      // setOrangeStyle() {
      //   import ('./assets/theme/orange.css');
      // },
      // setBlueStyle() {
      //   import ('./assets/theme/blue.css');
      // },
      //清除皮肤样式表
      removeSkin(){
        if(this.currentSkinStyle){
          document.head.removeChild(this.currentSkinStyle);
          this.currentSkinStyle = null;
        }
      },
      // 修改样式表
      changeIco() {
        let isRuralVitalization = false;//是否是乡村振兴
        if (this.returnDomain()) {
          isRuralVitalization = true;
        }
        let faviconlink = document.querySelector('link[rel="icon"]') || document.createElement('link');
        faviconlink.type = 'image/x-icon';
        faviconlink.rel = 'shortcut icon';
        const skinCss = document.createElement('link');
        skinCss.rel = "stylesheet";
        skinCss.type = "text/css";
        if(!localStorage.getItem('storeskinthemecolor') || localStorage.getItem('storeskinthemecolor') == 'undefined' || localStorage.getItem('storeskinthemecolor') == 'null') { //橙色
          skinCss.href = `${this.staticPath}/theme/orange.css`;
          document.body.style.setProperty('--main-color', '#ff9429'); 
          document.body.style.setProperty('--sub-color', '#fef3e6'); //辅助色变量值-橙色
          document.body.style.setProperty('--deep-color', '#f07d0a');
          faviconlink.href = 'https://presale.jhtsoft.com/picms/d3abf46f71dc.png';
        } else {
          if(!isRuralVitalization){
            this.storeskinthemecolor = Number(localStorage.getItem('storeskinthemecolor'));
            if(this.storeskinthemecolor == 1){ //蓝色
              skinCss.href = `${this.staticPath}/theme/blue.css`;
              document.body.style.setProperty('--main-color', '#3c9bfa'); 
              document.body.style.setProperty('--sub-color', '#ecf5ff'); //辅助色变量值-蓝色
              document.body.style.setProperty('--deep-color', '#1266BA');
              faviconlink.href = 'https://presale.jhtsoft.com/picms/233a6d675bd91.png';
            }else if(this.storeskinthemecolor == 2){ //绿色
              skinCss.href = `${this.staticPath}/theme/green.css`;
              document.body.style.setProperty('--main-color', '#24c424'); 
              document.body.style.setProperty('--sub-color', '#ecfaec'); //辅助色变量值-绿色
              document.body.style.setProperty('--deep-color', '#07bb07');
              faviconlink.href = 'https://presale.jhtsoft.com/picms/317fbd45a009c.png';
            }else{ //橙色
              skinCss.href = `${this.staticPath}/theme/orange.css`;
              document.body.style.setProperty('--main-color', '#ff9429'); 
              document.body.style.setProperty('--sub-color', '#fef3e6'); //辅助色变量值-橙色
              document.body.style.setProperty('--deep-color', '#f07d0a');
              faviconlink.href = 'https://presale.jhtsoft.com/picms/d3abf46f71dc.png';
            }
          }else{
            skinCss.href = `${this.staticPath}/theme/orange.css`;
            document.body.style.setProperty('--main-color', '#ff9429'); 
            document.body.style.setProperty('--sub-color', '#fef3e6'); //辅助色变量值-橙色
            document.body.style.setProperty('--deep-color', '#f07d0a');
            faviconlink.href = 'https://presale.jhtsoft.com/picms/d3abf46f71dc.png';
          }
        }
        console.log(faviconlink.href,'iconhref')
        if(this.currentSkinStyle) this.removeSkin();
        document.head.appendChild(skinCss);
        this.currentSkinStyle = skinCss;
        document.getElementsByTagName('head')[0].appendChild(faviconlink);
        document.title = isRuralVitalization ? '乡村振兴门店管理中心' : '门店管理中心'
      },
    },
    // =============================== 生命周期 ===============================
    created() {
      // this.changeIco();
      if (localStorage.getItem('userInfoMd')) {
        this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
      }
      window.addEventListener('visibilitychange', () => { //浏览器tab切换监听事件
        if (document.visibilityState == 'visible') { //状态判断：显示（切换到当前页面）
          // 切换到页面执行事件
          // console.log('wweerrr')
          let userBase = '';
          if (localStorage.getItem('userInfoMd')) {
            userBase = JSON.parse(localStorage.getItem('userInfoMd'));
          }
          if (!userBase) {
            if (this.$route.name != '登录') {
              this.$router.push({
                name: '登录'
              });
            }
            return false
          }
          if (this.userInfoMd && (this.userInfoMd.ucode != userBase.ucode)) {
            if (this.$route.name != '首页') {
              this.$router.push({
                name: '首页'
              })
            } else {
              window.location.reload();
            }
          }
        }
      });
    },
    mounted() { },
    computed: {
      ...mapState({
        isQKchild: ({ common }) => common.isQKchild, // 是否是子项目
        updateSkin: ({ common }) => common.updateSkin,
      })
    }
  };
</script>

<style scoped>
  /* .containerBox {position: relative;z-index:1;} */
  .mainBox {
    width: 100%;
    position: relative;
    top: 0px;
    left: 0;
    height: calc(100vh - 50px);
    overflow: hidden;
    -webkit-transition: -webkit-transform 0.4s;
    -moz-transition: -moz-transform 0.4s;
    transition: transform 0.4s;
    box-shadow: 0 0 30px #241d20;
  }

  .mainBox.scale-down {
    -webkit-transform: scale(0.9);
    -moz-transform: scale(0.9);
    -ms-transform: scale(0.9);
    -o-transform: scale(0.9);
    transform: scale(0.9);
  }

  .rightView {
    position: absolute;
    transition: all 0.3s;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* padding-top:50px; */
    background: #f6f8fb;
    /* will-change: transform;  */
  }
  /* #subapp-viewport {position:absolute;left:0; top:0; right:0; bottom:0; margin:auto;}
  .mainBox.upZindex {z-index:-1!important;} */
</style>


// WEBPACK FOOTER //
// src/App.vue